<template>
<v-row style="max-width: 600px; margin: 0 auto; height: 100%" >
        
        <v-col id="base" md="12" style="height: 100%; position: relative; display: flex; flex-direction: column; " class="mt-0 pt-0" >
            <!-- Header -->
            <v-row justify="center" align="center" :style="{ 'background-color': $store.state.colors.primary }" class="pb-3">
                <v-img max-width="230px" height="80px" contain :src="$store.state.logoSRC"></v-img>
            </v-row>
            <v-row justify="center" align="center" style="color: white" :style="{ 'background-color': $store.state.colors.accent }">
                <v-col class="ml-8 mt-0 pt-2">
                    <v-row >
                        Bienvenid@
                    </v-row>
                    <!-- <v-row style="font-size: 10px; ">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Phasellus lobortis est a faucibus feugiat.
                    </v-row> -->
                    <!-- <v-snackbar :value="alert" :top="true" color="error" transition="scale-transition">
                        {{alertMessage}}
                    </v-snackbar>
                    <v-snackbar :value="alert2" class="font" :top="true" color="success" transition="scale-transition">
                        {{alertMessage2}}
                    </v-snackbar>
                    <v-snackbar :value="alert3" class="font" :top="true" color="error" transition="scale-transition">
                        {{alertMessage3}}
                    </v-snackbar>
                    <v-snackbar :value="alert4" class="font" :top="true" color="warning" transition="scale-transition">
                        {{alertMessage4}}
                    </v-snackbar>
                    <v-snackbar :value="alert5" class="font" :top="true" color="info" transition="scale-transition">
                        {{alertMessage5}}
                    </v-snackbar>
                    <v-snackbar :value="alertRecover" class="font" :top="true" color="info" transition="scale-transition">
                        {{alertMessageRecover}}
                    </v-snackbar> -->
                </v-col>
            </v-row>
            <v-row style="height: 100%;" >
                <v-col >
                    <v-text-field 
                    v-model="user" 
                    label="Correo"  
                    outlined 
                    class="mt-0 mb-0"
                    :rules="[rules.required, rules.email]"
                    @keyup.enter="inSubmit()"
                    ></v-text-field>
                    <v-text-field 
                    label="Contraseña" 
                    outlined 
                    class="mt-0 mb-0"
                    v-model="password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="showPassword ? 'text' : 'password'"
                    name="input-10-1"
                    counter
                    @keyup.enter="inSubmit()"
                    @click:append="showPassword = !showPassword"
                    ></v-text-field>
                    <v-row justify="center" class="mt-0 mb-0">
                        <!-- :class="{'disable-events': !(!!password && !!user)}" -->
                        <v-btn :loading="loading" @click="inSubmit()"   class="text-left buttonLower mb-6" :color="$store.state.colors.primary" dark x-large style="width: 80%; height: 45px;  ">
                            <span style="float: left; padding-left:0px;">Entrar</span>
                            <v-spacer></v-spacer>
                            <v-img max-width="20px" src="@/assets/resources/yoomi/arrow_white.png"></v-img>
                        </v-btn>
                    </v-row>
                    <v-row justify="end" class="pr-6">
                        <a @click="recoverPass()" class="a" :disabled="checkDataEmail">¿Olvidaste tu contraseña?</a>
                    </v-row>
                    <v-row justify="end" class="pr-6">
                        <a @click="$router.push({ name: 'registerStep1'});" class="a" >Regístrate</a>
                    </v-row>
                    <!-- <v-row justify="center" align="center" style="width: 100%; position: absolute; left: 0px; bottom: 0px; margin: 0 auto;" :style="{ 'background-color': $store.state.colors.primary }" class="pt-0">
                        <v-btn @click="$router.push({ name: 'registerStep1'});" class="text-left buttonLower" color="white" x-large style="width: 93%; height: 55px; margin: 15px;" :style="{ 'color': $store.state.colors.primary }" > 
                            <span style="float: left; padding-left:0px;">Regístrate</span>
                            <v-spacer></v-spacer>
                            <v-img max-width="20px" src="@/assets/resources/yoomi/arrow.png"></v-img>
                        </v-btn>
                    </v-row> -->
                </v-col>
            </v-row>
    <!-- <v-row style="max-width: 600px; margin: 0 auto;" >
        <v-col id="base" md="12" style="height: 100%; " class="mt-0 pt-0" >
            <v-row justify="center" class="pb-8 pt-12">
                <h1>Autenticación</h1>
            </v-row>
            <v-row style="max-width: 350px; margin: 0 auto;">
                <v-text-field v-model="user" dense label="Usuario" solo></v-text-field>
            </v-row>
            <v-row style="max-width: 350px; margin: 0 auto;">
                <v-text-field
                    v-model="password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="showPassword ? 'text' : 'password'"
                    name="input-10-1"
                    label="Contraseña"
                    counter
                    @click:append="showPassword = !showPassword"
                ></v-text-field>
            </v-row>
            <v-row justify="center" style="margin: 0 auto" class="pt-4">
                <v-btn @click="inSubmit()" width="110px" class="buttonLower" color="black" style="color: white">Ingresar</v-btn>
            </v-row>
            <v-row justify="center" style="margin: 0 auto" class="pt-4">
                <v-btn @click="$router.push({ name: 'create_account'});" width="110px" class="buttonLower" color="black" style="color: white">Regístrate</v-btn>
            </v-row>
        </v-col>
    </v-row> -->
        </v-col>
</v-row>
</template>
<script>
import axios from 'axios';

    export default {
        name: 'Verification',
        data(){
            return {
                loading: false,
                alert: false,
                alert2: false,
                alert3: false,
                alert4: false,
                alert5: false,
                alertRecover: false,
                alertMessage: 'Usuario y/o Contraseña Incorrectas, Intenta de nuevo',
                alertMessage2: 'Correo Enviado Correctamente',
                alertMessage3: 'Cliente No Registrado',
                alertMessage4: '¡Falta llenar algún campo!',
                alertMessage5: 'Introduce tu correo y vuelve a hacer click',
                alertMessageRecover: "Enviando correo...",
                user: '',
                password: '',
                pass: false,
                confirmPassword: '',
                showPassword: false,
                showConfirm: false,
                emailPattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                rules: {
                    min: v => v ? (v.length >= 5 || "Mínimo 5 caracteres") : true,
                    equals: c => c ? (c == this.password || 'Las contraseñas no coinciden') : true,
                    email: value => { return value ? (this.emailPattern.test(value) || 'Correo no válido') : true },
                    required: value => !!value || ''
                },
            }
        },
        methods:
        {
            recoverPass()
            {
                this.$store.state.alertState = true;
                this.$store.state.alertMessage = this.alertMessageRecover;
                this.$store.state.alertColor = "info";
                setTimeout(() => {
                this.$store.state.alertState = false;
                }, 4000);
                if( this.user == '')
                {
                    this.$store.state.alertState = false;
                    this.$store.state.alertState = true;
                    this.$store.state.alertMessage = this.alertMessage5;
                    this.$store.state.alertColor = "info";
                    setTimeout(() => {
                    this.$store.state.alertState = false;
                    }, 4000);
                }
                else
                {
                    if(!this.checkDataEmail)
                    {
                        var username = 'swyt1';
                        var password = 'r3stoDirec0.y';
                        var basicAuth = 'Basic ' + btoa(username + ':' + password);
                        const headers = { 'Content-Type': 'application/json', 'Authorization': basicAuth}
                            // console.log(this.user)
                    axios.post('/recuperar', {correo: this.user}, {headers: headers})
                    .then(res =>{
                        console.log(res);
                        // console.log(res.data.mensaje)
                        if(res.data.mensaje == 'Correo enviado')
                            {
                                this.$store.state.alertState = false;
                                this.$store.state.alertState = true;
                                this.$store.state.alertMessage = this.alertMessage2;
                                this.$store.state.alertColor = "success";
                                setTimeout(() => {
                                this.$store.state.alertState = false;
                                }, 4000);
                            }
                            else
                            {
                                this.$store.state.alertState = false;
                                this.$store.state.alertState = true;
                                this.$store.state.alertMessage = this.alertMessage3;
                                this.$store.state.alertColor = "error";
                                setTimeout(() => {
                                this.$store.state.alertState = false;
                                }, 4000);
                            }
                    })
                    .catch(error => {
                        console.log(error);
                        this.$store.state.alertState = false;

                        this.alertMessage = "Algo salió mal, intentalo más tarde" 
                        this.$store.state.alertState = true;
                        this.$store.state.alertMessage = this.alertMessage;
                        this.$store.state.alertColor = "error";
                        setTimeout(() => {
                        this.$store.state.alertState = false;
                        }, 4000);
                        }
                        
                    );
                    } 
                }
            },
            async inSubmit ()
            {
                this.loading = true;
                this.$store.state.lista_platillos = []; 
                if( this.user == '' || this.password == '')
                {
                    this.loading = false;
                    this.$store.state.alertState = true;
                    this.$store.state.alertMessage = this.alertMessage4;
                    this.$store.state.alertColor = "warning";
                    setTimeout(() => {
                    this.$store.state.alertState = false;
                    }, 4000);
                }
                else
                {
                    
                        var username = 'swyt1';
                        var password = 'r3stoDirec0.y';
                        var basicAuth = 'Basic ' + btoa(username + ':' + password);
                    // console.log(basicAuth);
                        const headers = { 'Content-Type': 'application/json', 'Authorization': basicAuth}
                    this.$store.dispatch('login',{ 
                        user: this.user,
                        pass: this.password,
                        codigo_marca: this.$store.state.codigo_marca,
                        headers: headers
                    })
                    .then(res =>{
                        // console.log(res);
                        this.loading = false;
                        if(res.data.mensaje == 'No hay cobertura en tu zona')
                            {
                                this.alertMessage = "No hay cobertura en tu zona" 
                                this.$store.state.alertState = true;
                                this.$store.state.alertMessage = this.alertMessage;
                                this.$store.state.alertColor = "error";
                                setTimeout(() => {
                                this.$store.state.alertState = false;
                                }, 4000);                   
                            }
                        if(res.data.error == 'Error en datos de login')
                        {
                            this.alertMessage = "Usuario y/o Contraseña Incorrectas, Intenta de nuevo"
                            this.$store.state.alertState = true;
                            this.$store.state.alertMessage = this.alertMessage;
                            this.$store.state.alertColor = "error";
                            setTimeout(() => {
                            this.$store.state.alertState = false;
                            }, 4000);                    
                        }
                        else
                        {
                            if(res.data.id_sucursal == 0)
                                this.$router.push({ name: 'select_delivery'});
                            else
                            {
                                localStorage.setItem("solo_sucursal", "N");
                                this.$router.push({ name: 'menu'});
                            }
                        }
                    }) 
                    .catch(error => {
                        this.loading = false;
                            console.log(error);
                            this.alertMessage = "Algo salió mal, inténtalo más tarde" 
                            this.$store.state.alertState = true;
                            this.$store.state.alertMessage = this.alertMessage;
                            this.$store.state.alertColor = "error";
                            setTimeout(() => {
                            this.$store.state.alertState = false;
                            }, 4000); 
                        }
                    );  
                }
            }
        },
        created() {
            this.$store.state.logo = false;
            this.$store.state.validationDelivery=false;
        },
        computed:
        {
            checkDataEmail(){
                if (this.emailPattern.test(this.user)) 
                {
                    return this.user.length >= 8 ? false : true;
                } return true; 
            }
        }
    }
</script>

<style>
.disable-events 
{
    pointer-events: none;
}
.a:hover 
{ 
  background-color: white;
} 
.disable-events 
{
    pointer-events: none
}
.font
{
    font-size: 16px;
}
</style>